import * as icons from '../../assets/icons';
import {
  PERM_ROLES_MANAGE,
  PERM_USERS_PAGE_VIEW,
  PERM_STORES_PAGE_VIEW,
  PERM_STORE_LICENSE,
} from '../../config/permissions';
import { ORGANIZATION_TYPE } from '../../config/constants';
import { isImpersonating } from '../../utils';

export default [
  {
    title: 'All Stores',
    path: '/stores/list',
    icon: icons.HomeIcon,
    permission: PERM_STORES_PAGE_VIEW,
  },
  {
    title: 'Store Report',
    path: '/stores/report/status',
    icon: icons.OverviewIcon,
    permission: PERM_STORES_PAGE_VIEW,
  },
  ...(isImpersonating()
    ? [
        {
          title: 'Elevate  Report',
          path: '/stores/report/elevate',
          icon: icons.OverviewIcon,
        },
      ]
    : []),
  {
    title: 'Users',
    path: '/stores/users',
    icon: icons.UsersIcon,
    permission: PERM_USERS_PAGE_VIEW,
  },
  {
    title: 'Roles',
    path: '/stores/roles',
    icon: icons.RolesIcon,
    permission: PERM_ROLES_MANAGE,
  },
  {
    title: 'Branding',
    path: '/stores/customize-theme',
    icon: icons.BrandingIcon,
    permission: PERM_STORE_LICENSE,
    orgType: ORGANIZATION_TYPE.WHITE_LABELED,
  },
];
